export const links = [
    {
        "nombre" : "Programas Sociales",
        "link" : "/Programas",
        
    },
    {
        "nombre" : "Servicios",
        "link" : "/Servicios",
    
    },
    {
        "nombre" : "Transparencia",
        "link" : "/Transparencia",
        "submenu" : [
        ]
    },
    {
        "nombre" : "Ligas Interés",
        "link" : "/Ligasdeinteres",
        
    },
]